export const PurchasingGroupRole = {
    AUTHOR: "AUTHOR",
    ADMIN: "ADMIN",
    EXPERT: "EXPERT",
    MEMBER: "MEMBER"
}
